'use client';

export { default } from './InputLabel';
export { default as inputLabelClasses } from './inputLabelClasses';
export * from './inputLabelClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/InputLabel/index.js
// module id = 331
// module chunks = 25